import { render, staticRenderFns } from "./Robot_auto_detail.vue?vue&type=template&id=e1cf90d2&scoped=true&"
import script from "./Robot_auto_detail.vue?vue&type=script&lang=js&"
export * from "./Robot_auto_detail.vue?vue&type=script&lang=js&"
import style0 from "./Robot_auto_detail.vue?vue&type=style&index=0&id=e1cf90d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cf90d2",
  null
  
)

export default component.exports